module.exports = __webpack_public_path__ + "static/media/icon-close1.png";